import { render, staticRenderFns } from "./ServiceContact.vue?vue&type=template&id=4870c8c8&scoped=true&"
import script from "./ServiceContact.vue?vue&type=script&lang=js&"
export * from "./ServiceContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870c8c8",
  null
  
)

export default component.exports